var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Outer',[_c('div',{staticClass:"b-auth"},[_c('h2',{staticClass:"b-title _center"},[_vm._v(" 404 ")]),_c('p',{staticClass:"b-text _center"},[_vm._v(" Page not found. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }